import * as constants from "./constants";

const initialState = {
  allVarianceStatuses: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const varianceStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_VARIANCE_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_VARIANCE_STATUSES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allVarianceStatuses: [...state.allVarianceStatuses, action.data],
        isAdding: false,
      };
    case constants.CREATE_VARIANCE_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allVarianceStatuses: action.data,
      };
    case constants.UPDATE_ORDER_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_VARIANCE_STATUSES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_VARIANCE_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allVarianceStatuses: action.data,
        isAdding: false,
      };
    case constants.FETCH_VARIANCE_STATUSES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_VARIANCE_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_VARIANCE_STATUSES_SUCCESS:
      const updated = state.allVarianceStatuses.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allVarianceStatuses: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_VARIANCE_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_VARIANCE_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_VARIANCE_STATUSES_SUCCESS:
      const updatedData = state.allVarianceStatuses.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allVarianceStatuses: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_VARIANCE_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default varianceStatusReducer;
